import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './NavigationStyles';

export default class EnergyServicesNavigation extends Component {
  render() {
    const { pathname } = this.props
    
    return (
      <div className={css(styles.navigation)}>
        <nav className={css(styles.innerContent)}>
          <ul className={css(styles.list)}>
            <li className={css(styles.listItem)}>
              <a href="/my-home" className={css(styles.link, styles.iconToday, pathname === "/my-home" && styles.active)}>
                <span className={css(styles.text)}>Today</span>
              </a>
            </li>
            <li className={css(styles.listItem)}>
              <a href="/my-home/usage" className={css(styles.link, styles.iconUsage, pathname === "/my-home/usage" && styles.active)}>
                <span className={css(styles.text)}>Usage</span>
              </a>
            </li>
            <li className={css(styles.listItem)}>
              <a href="/my-home/rankings" className={css(styles.link, styles.iconRankings, pathname === "/my-home/rankings" && styles.active)}>
                <span className={css(styles.text)}>Rankings</span>
              </a>
            </li>
            <li className={css(styles.listItem)}>
              <a href="/my-home/appliances" className={css(styles.link, styles.iconAppliances, (pathname === "/my-home/appliances" || pathname.indexOf("/my-home/appliance/") === 0) && styles.active)}>
                <span className={css(styles.text)}>Appliances</span>
              </a>
            </li>
            <li className={css(styles.listItem)}>
              <a href="/my-home/feedback" className={css(styles.link, styles.iconFeedback, pathname === "/my-home/feedback" && styles.active)}>
                <span className={css(styles.text)}>Feedback</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}
